import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { CookieConsentModal } from "./cookie-consent-modal";

export function CookieConsentBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const hasConsent = localStorage.getItem('cookie-consent-given');
    if (!hasConsent) {
      setShowBanner(true);
    }
  }, []);

  const handleAcceptAll = () => {
    const allAccepted = {
      necessary: true,
      analytics: true,
      advertisement: true,
    };
    localStorage.setItem('cookie-preferences', JSON.stringify(allAccepted));
    localStorage.setItem('cookie-consent-given', 'true');
    setShowBanner(false);
  };

  const handleManageCookies = () => {
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <>
      {/* Cookie Consent Banner */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
        <div className="max-w-7xl mx-auto p-4">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex-1">
              <p className="text-sm text-gray-600 leading-relaxed">
                We use cookies to improve your experience on our site and for marketing purposes.
                By continuing to browse, you agree to our{" "}
                <a href="/privacy-policy" className="text-blue-600 hover:underline">
                  Privacy Policy
                </a>
                {" "}and{" "}
                <a href="/cookie-policy" className="text-blue-600 hover:underline">
                  Cookie Policy
                </a>
                .
              </p>
            </div>
            <div className="flex gap-3 shrink-0">
              <Button
                variant="outline"
                onClick={handleManageCookies}
                className="text-sm px-4 py-2 border-gray-300 text-gray-700 hover:bg-gray-50"
              >
                Manage cookies
              </Button>
              <Button
                onClick={handleAcceptAll}
                className="text-sm px-4 py-2 bg-[#1a73e8] hover:bg-[#1557b0] text-white"
              >
                Accept All
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Cookie Management Modal */}
      <CookieConsentModal 
        open={showModal} 
        onOpenChange={setShowModal}
      />
    </>
  );
}